import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'changeToCode',
})
export class ChangeToCodePipe implements PipeTransform {
	transform(number: number, myHTML: string = ''): string {
		let code: string;
		if (number === 0) {
			code = 'OX';
		} else if (number === 1) {
			code = 'SA';
		} else if (number === 2) {
			code = myHTML;
		} else if (number === 3) {
			code = `${myHTML}, OX`;
		} else if (number === 4) {
			code = 'ACD';
		} else if (number === 5) {
			code = 'ALK';
		} else if (number === 6) {
			code = 'COR';
		} else {
			code = number.toString();
		}
		return code;
	}
}
